<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				:fill="color"
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M11 0C4.92383 0 0 4.31029 0 9.62339C0 12.661 1.6112 15.367 4.12554 17.1294V22L8.94196 19.0758C9.6105 19.1832 10.2945 19.2468 11 19.2468C17.0753 19.2468 22 14.9408 22 9.62339C22 4.31029 17.0753 0 11 0ZM7.33305 11.6111C7.33305 11.2736 7.60665 11 7.94416 11H14.0553C14.3928 11 14.6664 11.2736 14.6664 11.6111C14.6664 11.9486 14.3928 12.2222 14.0553 12.2222H7.94416C7.60665 12.2222 7.33305 11.9486 7.33305 11.6111ZM6.11111 7.94449C5.7736 7.94449 5.5 8.2181 5.5 8.5556C5.5 8.89311 5.7736 9.16671 6.11111 9.16671H15.8889C16.2264 9.16671 16.5 8.89311 16.5 8.5556C16.5 8.2181 16.2264 7.94449 15.8889 7.94449H6.11111Z"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBothMessage',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
